export default function(node: Element): Document {
  return (node && node.ownerDocument) || document;
}
